// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { SnowtamGrouped } from '../../AftnMessages/Snowtam';
import { TSnowtamGroup } from '../../../interfaces';

export const SnowtamCols: ColumnsType<TSnowtamGroup> = [
	{
		title: 'ICAO',
		dataIndex: 'icao',
		// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
		render: (_, obj) => {
			return (
				<div className={'aftnMessageTable'}>
					<SnowtamGrouped group={obj} />
				</div>
			);
		},
	},
];
